import { render, staticRenderFns } from "./emailDialog.vue?vue&type=template&id=7c6708a8&scoped=true"
import script from "./emailDialog.vue?vue&type=script&lang=js"
export * from "./emailDialog.vue?vue&type=script&lang=js"
import style0 from "./emailDialog.vue?vue&type=style&index=0&id=7c6708a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6708a8",
  null
  
)

export default component.exports